import { render } from "./TheFooter.vue?vue&type=template&id=e5b7df96&scoped=true"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=e5b7df96&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5b7df96"]])

export default __exports__